// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VC2B","input":"styles_input__2yFne"};